import PropTypes from 'prop-types'
import React from 'react'

import PostLink from '../post-link'
import StickyHeader from 'components/sticky-header'

export default class PostNavBar extends React.Component {
  static propTypes = {
    hideTitle: PropTypes.bool,
    nextPost: PropTypes.object,
    previousPost: PropTypes.object,
    shareProps: PropTypes.object,
    title: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
      .isRequired,
  }

  static contextTypes = {
    minimalView: PropTypes.bool,
  }

  constructor(props) {
    super(props)

    this.state = { microUtilityEnabled: false }
  }

  componentDidMount() {
    this.setState({ microUtilityEnabled: window && !window.currentUser })
  }

  previousPostButton = () =>
    this.props.previousPost ? (
      <PostLink
        className="hidden-xs"
        direction="left"
        post={this.props.previousPost}
      />
    ) : null

  nextPostButton = () =>
    this.props.nextPost ? (
      <div className="hidden-xs full-width text-right">
        <PostLink direction="right" post={this.props.nextPost} />
      </div>
    ) : null

  render() {
    const { children, title, hideTitle } = this.props
    return (
      <StickyHeader
        title={title}
        leftActionComponent={
          <React.Fragment>{this.previousPostButton()}</React.Fragment>
        }
        rightActionComponent={this.nextPostButton()}
        hideTitle={this.context.minimalView}
        utilityBarEnabled={this.state.microUtilityEnabled}
      >
        {children}
      </StickyHeader>
    )
  }
}
